import React from "react";
import StockHoldingsTable from "./components/StockHoldingsTable";

const App = () => {
  return (
    <div className="container">
      <StockHoldingsTable />
    </div>
  );
};

export default App;
